import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuth";
import { LOGO_URL } from "../../data/content";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { admin, login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(err.response?.data?.detail || "Erreur de connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center px-6"
      style={{ background: "radial-gradient(900px 500px at 20% 30%, #ffd1dc 0%, transparent 60%), radial-gradient(700px 400px at 80% 70%, #fff5d6 0%, transparent 60%), #fbf7f2" }}
    >
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="bg-white rounded-[32px] p-8 md:p-12 w-full max-w-md shadow-[0_20px_60px_rgba(229,91,91,0.12)] border border-amyu"
      >
        <img src={LOGO_URL} alt="Amyu" className="h-14 mx-auto" />
        <h1 className="font-display text-3xl text-center mt-4">
          Espace <span className="italic text-coral">équipe</span>
        </h1>
        <p className="text-center text-sm text-amyu-muted mt-2">Réservé à l'équipe Amyu</p>

        <label className="block mt-7 text-xs uppercase tracking-widest text-amyu-muted">Email</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="admin-login-email"
          className="mt-2 w-full bg-amyu-cream rounded-full px-5 py-3.5 outline-none focus:ring-2 focus:ring-coral/30"
        />

        <label className="block mt-4 text-xs uppercase tracking-widest text-amyu-muted">Mot de passe</label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          data-testid="admin-login-password"
          className="mt-2 w-full bg-amyu-cream rounded-full px-5 py-3.5 outline-none focus:ring-2 focus:ring-coral/30"
        />

        {error && (
          <p data-testid="admin-login-error" className="mt-4 text-sm text-coral text-center">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit"
          className="btn-coral w-full mt-7 inline-flex items-center justify-center gap-2 disabled:opacity-60"
        >
          <Lock size={16} />
          {loading ? "Connexion..." : "Se connecter"}
        </button>

        <a href="/" className="block mt-5 text-center text-xs text-amyu-muted hover:text-coral">
          ← Retour au site
        </a>
      </form>
    </div>
  );
}
